import { useCallback, useState } from 'react';

import { isEmptyObject } from '../../utils';
import { Storyblok } from '../../storyblok';

export const useFormFields = (
    fields: Storyblok.Component.InputField[],
    initialData?: any,
) => {
    /** @type {[FieldValues, SetFieldValues]} */
    const [fieldValues, setFieldValues] = useState(() => {
        /**
         * Sometimes the backend returns the `null` value and we cannot
         * directly parse it into field value then send it back to backend
         * because it will throw an error. In that case we simply parse it
         * into empty string.
         */
        return Object.assign(
            {},
            ...fields.map(({ name, type }) => {
                if (type === 'checkbox' && name) {
                    return {
                        [name]:
                            isEmptyObject(initialData) || !initialData[name]
                                ? false
                                : initialData[name],
                    };
                }

                if (name) {
                    return {
                        [name]:
                            isEmptyObject(initialData) || !initialData[name]
                                ? ''
                                : initialData[name],
                    };
                }
            }),
        );
    });

    /** Iterates over fieldValues and sets every field value to empty string */
    const resetFieldValues = useCallback(() => {
        setFieldValues(
            Object.assign(
                {},
                ...Object.keys(fieldValues).map((key) => ({ [key]: '' })),
            ),
        );
    }, [fieldValues]);

    return [fieldValues, setFieldValues, resetFieldValues];
};
